
import { defineComponent } from 'vue';
import TextoVisualizacao from './TextoVisualizacao.vue';
import TextoEdicao from './TextoEdicao.vue';
import { TextoEditavel } from '@/dominio/editor/questoes/comum/texto/TextoEditavel';

export default defineComponent({
    name: 'ItemDeTexto',
    components: {
        TextoVisualizacao,
        TextoEdicao,
    },
    props: {
        texto: { type: TextoEditavel, required: true },
        ehPrimeiro: { type: Boolean, required: true },
        ehUltimo: { type: Boolean, required: true },
    },
    methods: {
        editar(texto: TextoEditavel) {
            this.$emit('editar', texto);
        },
        excluir(texto: TextoEditavel) {
            this.$emit('excluir', texto);
        },
        descer(texto: TextoEditavel) {
            this.$emit('descer', texto);
        },
        subir(texto: TextoEditavel) {
            this.$emit('subir', texto);
        },
        selecionar(texto: TextoEditavel) {
            this.$emit('selecionar', texto);
        },
    },
    emits: ['editar', 'excluir', 'descer', 'subir', 'selecionar'],
});
